import { Component } from '@angular/core';

@Component({
    selector: 'atlas-profiler-reports',
    templateUrl: './profiler-reports.component.html',
    styleUrls: ['./profiler-reports.component.less'],
    standalone: false
})
export class ProfilerReportsComponent {}
